import React from "react";

interface UploadIconProps {
  width?: string;
  height?: string;
  fill?: string;
}

const UploadIcon: React.FC<UploadIconProps> = ({
  width = "18",
  height = "18",
  fill = "#731DCF",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.58909 0.910742C9.26366 0.585305 8.73602 0.585305 8.41058 0.910742L4.24392 5.07741C3.91848 5.40285 3.91848 5.93048 4.24392 6.25592C4.56935 6.58136 5.09699 6.58136 5.42243 6.25592L8.1665 3.51184V11.5C8.1665 11.9602 8.5396 12.3333 8.99984 12.3333C9.46007 12.3333 9.83317 11.9602 9.83317 11.5V3.51184L12.5772 6.25592C12.9027 6.58136 13.4303 6.58136 13.7558 6.25592C14.0812 5.93048 14.0812 5.40285 13.7558 5.07741L9.58909 0.910742Z"
        fill={fill}
      />
      <path
        d="M2.33317 11.5C2.33317 11.0398 1.96007 10.6667 1.49984 10.6667C1.0396 10.6667 0.666504 11.0398 0.666504 11.5V14.8333C0.666504 15.4964 0.929896 16.1323 1.39874 16.6011C1.86758 17.0699 2.50346 17.3333 3.1665 17.3333H14.8332C15.4962 17.3333 16.1321 17.0699 16.6009 16.6011C17.0698 16.1323 17.3332 15.4964 17.3332 14.8333V11.5C17.3332 11.0398 16.9601 10.6667 16.4998 10.6667C16.0396 10.6667 15.6665 11.0398 15.6665 11.5V14.8333C15.6665 15.0543 15.5787 15.2663 15.4224 15.4226C15.2661 15.5789 15.0542 15.6667 14.8332 15.6667H3.1665C2.94549 15.6667 2.73353 15.5789 2.57725 15.4226C2.42097 15.2663 2.33317 15.0543 2.33317 14.8333V11.5Z"
        fill={fill}
      />
    </svg>
  );
};

export default UploadIcon;
